import { FaRegUserCircle } from 'react-icons/fa';
import { IoMailOutline } from 'react-icons/io5';
import { BsGlobe } from 'react-icons/bs';
import { MdStoreMallDirectory, MdVideoLibrary } from 'react-icons/md';
import './pending.css';
import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { trcUserAtom } from '@/TRC/atoms/trc-global';
import { buildRoutes } from '@/service/buildRoutes';
import TRCFormTitle from '@/TRC/pages/Access/components/trcHeading/trcTitle';
import TRCInfoField from '@/TRC/pages/Access/components/infoField/infoField';
import TRCRequestButton from '@/TRC/pages/Access/components/trcButton/trcButton';

const TRCPendingPage = () => {
	const trcUser = useAtomValue(trcUserAtom);
	const navigate = useNavigate();
	const formatRole = role => {
		return role
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	};

	const formatRoles = (roles = []) => {
		if (!roles.length) return '';

		const formatted = roles.map(formatRole);
		if (formatted.length === 1) return formatted[0];
		return `${formatted.slice(0, -1).join(', ')} & ${formatted[formatted.length - 1]}`;
	};

	const userRole = formatRoles(trcUser?.role);

	return (
		<>
			<TRCFormTitle>Your Application is Pending</TRCFormTitle>
			<div className="w-100 px-md-5 my-md-5">
				<div className="trc-info-grid">
					<TRCInfoField label="Full Name" value={trcUser?.name} icon={<FaRegUserCircle />} />
					<TRCInfoField label="Email Address" value={trcUser?.email} icon={<IoMailOutline />} />
					<TRCInfoField label="Instagram or Website" value={trcUser?.link} icon={<BsGlobe />} />
					<TRCInfoField label="Role" value={userRole} icon={<MdStoreMallDirectory />} />
				</div>
				<TRCInfoField label="What are you hoping to gain from Teacher Resource Center?" value={trcUser?.gain || ''} />
			</div>
			<div className="d-flex flex-column gap-1">
				<TRCRequestButton onClick={() => navigate(buildRoutes.toTRCResubmit())} icon={<MdVideoLibrary />}>
					EDIT APPLICATION
				</TRCRequestButton>
				<TRCRequestButton onClick={() => navigate(buildRoutes.toAllVideos())} icon={<MdVideoLibrary />}>
					Continue to enjoy our video library
				</TRCRequestButton>
			</div>
		</>
	);
};

export default TRCPendingPage;
